import React from 'react';
import {
  TableBody as MuiTableBody,
  Typography
} from '@material-ui/core';
import TableRow from './TableRow';
import TableCell from './TableCell';
import { searchFilter, sortFilter } from 'components/Search';

const TableBody = (props) => {
  const {
    pagination,
    columnCount,
    model,
    keyword,
    children,
    page,
    alignNoData,
    sortType,
    activeName,
    ...ref
  } = props;

  const searchAndSort = (data) => sortFilter(activeName, sortType, searchFilter(keyword || '')(data))
  const rows = (typeof children === 'function') ? children(searchAndSort) : children;
  const rowCount = React.Children.toArray(rows).length;
  const noData = (
    <TableRow>
      <TableCell colSpan={columnCount} align={alignNoData || 'center'}>
        <Typography>Tidak ada data</Typography>
      </TableCell>
    </TableRow>
  )

  if ((typeof pagination === 'number') && (rowCount > pagination)) {
    // const { page } = this.state;
    const startNumber = pagination * page;
    let endNumber = startNumber + pagination;
    endNumber = (endNumber <= rowCount) ? endNumber : rowCount;

    return (
      <MuiTableBody {...ref}>
        {rowCount > 0
          ? React.Children.toArray(rows).slice(startNumber, endNumber).map(child => React.cloneElement(child, { variant: 'body' }))
          : noData
        }
      </MuiTableBody>
    )
  } else {
    return (
      <MuiTableBody {...ref}>
        {rowCount > 0
          ? React.Children.toArray(rows).map(child => React.cloneElement(child, { variant: 'body' }))
          : noData
        }
      </MuiTableBody>
    )
  }
}

export default TableBody;
